const pageSection = 'tv';
export const searchRoute = i18n => ({
  pageId: 'search',
  pageType: 'navigationpage',
  pageSection,
  path: `/${i18n.t('routes.search')}`,
  remixRoute: 'SearchPage.remix-route.tsx',
  showScrollTop: true
});
export const getSearchQueryUrl = (baseUrl, i18n, searchTerm) => `${baseUrl}${searchRoute(i18n).path}?query=${searchTerm}`;